const typography = {
  fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
  h1: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h3: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h6: {
    fontFamily: "proxima-soft, 'proxima-soft-fallback', sans-serif",
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  button: {
    fontWeight: 600,
    textTransform: 'none',
    letterSpacing: '0.02em',
  },
  caption: {
    fontSize: '0.75rem',
    lineHeight: 1.4,
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    lineHeight: 1.4,
  },
};

export default typography;
